import { HTMLAttributes } from "react";
import { linearGradientPrimary } from "./commonCss";
import { ChildrenOnlyProp } from "./commonProps";

export type NavProps = Omit<HTMLAttributes<HTMLElement>, "className"> & {
  primaryGradient?: boolean;
};

export type NavBrandProps = Omit<HTMLAttributes<HTMLDivElement>, "className">;

export type NavItemProps = Omit<HTMLAttributes<HTMLDivElement>, "className"> & { customClass?: string };

export const Nav: React.FC<NavProps> = ({ children, primaryGradient }) => {
  const className = ["p-4 md:h-20 h-16 text-white flex items-center"].join(" ");

  return (
    <nav
      className={className}
      style={{
        background: primaryGradient ? linearGradientPrimary : undefined,
      }}
    >
      <div className="py-0 lg:px-[50px] md:px-[25px] flex w-full justify-between">{children}</div>
    </nav>
  );
};

export const NavBrand: React.FC<NavBrandProps> = ({ children, ...props }) => {
  return (
    <div {...props} className="flex items-center gap-4 md:mr-4">
      {children}
    </div>
  );
};

export const NavItem: React.FC<NavItemProps> = ({ children, customClass, ...props }) => {
  return (
    <div {...props} className={`whitespace-nowrap select-none ${customClass}`}>
      {children}
    </div>
  );
};

export const NavEnd: React.FC<ChildrenOnlyProp> = ({ children }) => {
  return <div className="flex items-center justify-end gap-x-4 lg:gap-x-8 gap-y-4 nav-end">{children}</div>;
};

export const NavStart: React.FC<ChildrenOnlyProp> = ({ children }) => {
  return <div className="hidden md:inline-flex items-center grow justify-start gap-x-8 nav-start">{children}</div>;
};
